const types = ['text', 'file', 'multiFile', 'number', 'numberCalculator', 'select', 'assetHours', 'calculator'] as const
const typesMap = {
  text: 'text',
  file: 'file',
  multiFile: 'multiFile',
  number: 'number',
  numberCalculator: 'numberCalculator',
  select: 'select',
  assetHours: 'assetHours',
  calculator: 'calculator',
}

type ChecklistComponentType = typeof types[number]

/**
 * Map between checklist component type
 */
function mapComponentType<T>(
  type: string,
  callbacks: {
    [key in ChecklistComponentType]?: () => T
  } & { onElse: () => T }
) {
  if (typesMap[type as keyof typeof typesMap]) {
    return callbacks[type as ChecklistComponentType]?.() ?? callbacks.onElse()
  }
  return callbacks.onElse()
}

/**
 * Map between checklist component type
 */
function mapObjectWithComponentType<O extends { type: ChecklistComponentType }, T>(
  object: O,
  callbacks: {
    [key in ChecklistComponentType]?: (component: O & { type: key }) => T
  } & { onElse: () => T }
) {
  if (typesMap[object.type as keyof typeof typesMap]) {
    return callbacks[object.type as ChecklistComponentType]?.(object as any) ?? callbacks.onElse()
  }
  return callbacks.onElse()
}

export { mapComponentType, mapObjectWithComponentType, ChecklistComponentType }
